import { create } from 'zustand';
import { ICanaryRequestStore } from './types';

export const useCanaryRequestStore = create<ICanaryRequestStore>((set) => ({
  canaryRequestAppointmentId: null,
  setCanaryRequestAppointmentId: (canaryRequestAppointmentId) =>
    set({ canaryRequestAppointmentId }),
  clearCanaryRequestAppointmentId: () =>
    set({ canaryRequestAppointmentId: null }),
}));
